export const de = {
  appName: 'Sudoku',
  tagline: 'Klar. Ruhig. Ganz bei dir.',
  settings: 'Einstellungen',
  language: 'Sprache',
  german: 'Deutsch',
  english: 'Englisch',
  theme: 'Farbschema',
  lightTheme: 'Hell',
  darkTheme: 'Dunkel',
  foundationTitle: 'Bereit für das Spiel',
  foundationMessage:
    'Das technische Fundament steht. Der spielbare Sudoku-Bereich entsteht im nächsten Schritt.',
  localTitle: 'Lokal',
  localDescription: 'Spielstand und Einstellungen bleiben in diesem Browser.',
  accessibleTitle: 'Zugänglich',
  accessibleDescription: 'Für Tastatur, Maus, Touch und assistive Technologien vorbereitet.',
  responsiveTitle: 'Flexibel',
  responsiveDescription: 'Entwickelt für Smartphone, Tablet und Computer.',
  milestone: 'Projektfundament',
  gameTitle: 'Dein Sudoku',
  boardLabel: 'Sudoku-Spielfeld',
  pausedBoard: 'Spielfeld während der Pause verborgen',
  fixedCell: 'vorgegeben',
  editableCell: 'bearbeitbar',
  emptyCell: 'leer',
  cellValue: 'Wert',
  cellCandidates: 'Notizen',
  conflictCell: 'Konflikt',
  incorrectCell: 'falscher Wert',
  row: 'Zeile',
  column: 'Spalte',
  easy: 'Leicht',
  medium: 'Mittel',
  hard: 'Schwer',
  difficulty: 'Schwierigkeit',
  newGame: 'Neues Spiel',
  generating: 'Sudoku wird erstellt …',
  generationFailed: 'Das Sudoku konnte nicht erstellt werden.',
  tryAgain: 'Erneut versuchen',
  timer: 'Spielzeit',
  pause: 'Pause',
  resume: 'Fortsetzen',
  paused: 'Spiel pausiert',
  undo: 'Rückgängig',
  redo: 'Wiederholen',
  erase: 'Löschen',
  notes: 'Notizen',
  numberPad: 'Zahleneingabe',
  gameActions: 'Spielaktionen',
  restart: 'Neu starten',
  completed: 'Geschafft! Du hast das Sudoku gelöst.',
  failedGame: 'Leider verloren. Drei Fehler sind erreicht.',
  mistakes: 'Fehler',
  mistakeStatus: 'Fehlerstand',
  selected: 'ausgewählt',
  cancel: 'Abbrechen',
  confirmRestartTitle: 'Spiel neu starten?',
  confirmRestartMessage: 'Alle Eingaben und Notizen in diesem Sudoku gehen verloren.',
  confirmRestartAction: 'Spiel neu starten',
  confirmNewGameTitle: 'Neues Spiel starten?',
  confirmNewGameMessage: 'Alle Eingaben und Notizen im aktuellen Sudoku gehen verloren.',
  confirmNewGameAction: 'Neues Spiel starten',
} as const;

export type TranslationKey = keyof typeof de;
export type Translations = Readonly<Record<TranslationKey, string>>;
